import { type AdServerAdBannerSizes } from '../../ad-server'

export const SEARCH_PAGE_AD_BANNER_SEARCH_TOP = 'pl-b3'
export const SEARCH_PAGE_AD_BANNER_SEARCH_MIDDLE = 'pl-b1'
export const SEARCH_PAGE_AD_BANNER_SEARCH_BOTTOM = 'pl-b2'

export const SEARCH_PAGE_AD_BANNER_SEARCH_TOP_DIMENSIONS: AdServerAdBannerSizes =
  {
    large: { height: 140, width: 728 },
    small: { height: 135, width: 347 },
  }

export const SEARCH_PAGE_AD_BANNER_SEARCH_MIDDLE_DIMENSIONS: AdServerAdBannerSizes =
  {
    large: { height: 140, width: 728 },
    small: { height: 135, width: 347 },
  }

export const SEARCH_PAGE_AD_BANNER_SEARCH_BOTTOM_DIMENSIONS: AdServerAdBannerSizes =
  {
    large: { height: 140, width: 728 },
    small: { height: 135, width: 347 },
  }

// Represents positions/indexes in the search results list where Ad banners will be inserted
export const SEARCH_PAGE_AD_BANNER_SEARCH_MIDDLE_POSITION = 3
export const SEARCH_PAGE_AD_BANNER_SEARCH_BOTTOM_POSITION = 7
